
import { css } from 'lit';
export default css`
.legal {font-family: Lato, sans-serif;font-size: 0.875rem;font-weight: 600;text-transform: uppercase;line-height: 1.4
}@media (min-width: 1024px) {.legal {font-size: 1rem
    }
}
`;